<template>
    <div class="h-100">
        todo
    </div>
</template>

<script>
export default {
  data () {
    return {
      filter: null,
      page: 1
    }
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    showPagination: {
      default: true,
      type: Boolean,
      required: false
    },
    perPage: {
      default: 20,
      type: Number,
      required: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/datatable/DropdownBase.vue